export class Toast {
    show(option) {
        if (!this.$toastEl) {
            this.initToast();
        }
        this.$toastEl.find('.toast_body').text(option.text)
            .show();
        this.$toastEl.fadeIn();
        setTimeout(() => this.$toastEl.fadeOut(), option.duration || 2000);
    }
    initToast() {
        const $df = $(document.createDocumentFragment());
        $df.append(`
        <div class="mod_toast" id="toast_body" style="display:none">
          <p class="toast_body">未知错误</p>
        </div>
      `);
        this.$toastEl = $df.children('#toast_body');
        this.$toastEl.appendTo(document.body);
    }
}
export const toast = new Toast();
